import { FileSignature, Rocket, Settings2, UserPlus } from 'lucide-react';
import ConfiguracionComercial from '../comercial/ConfiguracionComercial';
import Cotizaciones from '../comercial/Cotizaciones';
import Prospectos from '../comercial/Prospectos';
import TuEmpresaEnMarcha from '../comercial/TuEmpresaEnMarcha';

/* =====================================================================
   Las pantallas del carril `erp-comercial` · ERP-OPERATIVO EC1–EC5
   =====================================================================
   Un grupo propio, «Comercial». Prospectos y cotizaciones van por la
   llave `comercial.pipeline` (ENCARGADO y arriba, migración 440); la
   configuración por `comercial.configurar` (ADMIN); el arranque es del
   ADMIN porque es quien pone la empresa a operar.
   ===================================================================== */
export default {
  orden: 55,
  grupos: [{
    grupo: 'Comercial',
    items: [
      { id: 'comercial-prospectos', etiqueta: 'Prospectos', icono: UserPlus, permiso: 'comercial.pipeline', min: 'ENCARGADO', Comp: Prospectos },
      { id: 'comercial-cotizaciones', etiqueta: 'Cotizaciones', icono: FileSignature, permiso: 'comercial.pipeline', min: 'ENCARGADO', Comp: Cotizaciones },
      { id: 'comercial-configuracion', etiqueta: 'Configuración comercial', icono: Settings2, permiso: 'comercial.configurar', min: 'ADMIN', Comp: ConfiguracionComercial },
      { id: 'comercial-arranque', etiqueta: 'Primer arranque', icono: Rocket, min: 'ADMIN', Comp: TuEmpresaEnMarcha },
    ],
  }],
};
